import pembelian_produk from "../views/pembelian_produk/index.vue";
import pembelian_produk_create from "../views/pembelian_produk/create.vue";
import pembelian_produk_edit from "../views/pembelian_produk/edit.vue";
import pembelian_produk_detail from "../views/pembelian_produk/detail.vue";

const routes = [
  {
    path: "/pembelian_produk",
    name: "pembelian_produk",
    component: pembelian_produk,
    meta: { authOnly: true },
  },
  {
    path: "/pembelian_produk/create",
    name: "pembelian_produk_create",
    component: pembelian_produk_create,
    meta: { authOnly: true },
  },
  {
    path: "/pembelian_produk/edit/:uuid",
    name: "pembelian_produk_edit",
    component: pembelian_produk_edit,
    meta: { authOnly: true },
  },
  {
    path: "/pembelian_produk/detail/:uuid",
    name: "pembelian_produk_detail",
    component: pembelian_produk_detail,
    meta: { authOnly: true },
  },
];

export default routes;
